module.exports = __webpack_public_path__ + "media/entities/2309-d413ae59.png";